import { GridRow, GridRowProps, useGridApiContext } from '@mui/x-data-grid';
import React from 'react';

interface Props extends GridRowProps {
  idPrefix?: string;
}

const GridRowWithId: React.FC<Props> = ({ idPrefix, ...rest }) => {
  const apiRef = useGridApiContext();
  const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rest.rowId);

  return <GridRow {...rest} id={`${idPrefix ?? ''}row-${rowIndex}`} />;
};

export default GridRowWithId;
